
import React from "react";
import { Button } from "@/components/ui/button";
import { FormFieldComponent } from "../FormField";
import { FormField } from "@/components/dashboard/shops/types";
import { Plus } from "lucide-react";

interface FormFieldsListProps {
  formFields: FormField[];
  isEditing: boolean;
  toggleFieldEnabled: (id: string) => void;
  toggleFieldRequired: (id: string) => void;
  deleteField: (id: string) => void;
  updateFieldName: (id: string, name: string) => void;
  updateFieldType?: (id: string, type: FormField['type']) => void;
  addNewField: () => void;
}

export const FormFieldsList: React.FC<FormFieldsListProps> = ({
  formFields,
  isEditing,
  toggleFieldEnabled,
  toggleFieldRequired,
  deleteField,
  updateFieldName,
  updateFieldType,
  addNewField
}) => {
  return (
    <div className="space-y-4 mt-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">Champs du formulaire</h3>
        <p className="text-sm text-gray-500">
          {formFields.filter(f => f.enabled).length} champ(s) actif(s)
        </p>
      </div>
      
      {formFields.map((field) => (
        <FormFieldComponent 
          key={field.id}
          field={field}
          isEditing={isEditing}
          toggleFieldEnabled={toggleFieldEnabled}
          toggleFieldRequired={toggleFieldRequired}
          deleteField={deleteField}
          updateFieldName={updateFieldName}
          updateFieldType={updateFieldType}
        />
      ))}
      
      {isEditing && (
        <Button 
          variant="outline" 
          className="w-full flex items-center justify-center gap-2 mt-2 border-dashed"
          onClick={addNewField}
        >
          <Plus className="h-4 w-4" />
          Ajouter un champ
        </Button>
      )}
    </div>
  );
};
